import React from 'react'
import './Wgbs.css'
import ideation from '../../../../assets/img/ideation.svg'
import cca from '../../../../assets/img/cca.svg'
import iud from '../../../../assets/img/iud.svg'
import dp from '../../../../assets/img/dp.svg'
import rt from '../../../../assets/img/rt.svg'
import deployment from '../../../../assets/img/deployment.svg'
import sam from '../../../../assets/img/sam.svg'
import { FaChevronRight } from 'react-icons/fa6'
import { useNavigate } from 'react-router-dom';

function Wgbs() {

    const navigate = useNavigate();
  
    const wgbslist = [
        {
            icon: ideation,
            title: "Ideation",
            desc: "The journey begins with creative idea generation, brainstorming sessions, and thorough validation to ensure the viability of concepts. At 360 Bytes, we believe that every great project starts with a solid foundation of innovative ideas."
        },
        {
            icon: cca,
            title: "Conducting Competitive Analysis",
            desc: "Our team conducts a comprehensive competitive analysis, gathering relevant information and market insights. This stage helps us formulate a well-structured strategy tailored to your business goals."
        },
        {
            icon: iud,
            title: "Intuitive UI/UX Design",
            desc: "Next, we focus on creating a visually appealing and user-centric interface with intuitive navigation. Our goal is to effectively convey your brand's message while ensuring an engaging and seamless user experience."
        },
        {
            icon: dp,
            title: "Development Phase",
            desc: "As a reputable web app development company, 360 Bytes dedicates itself to crafting responsive and custom web applications that precisely align with our client's specific requirements. Our development phase ensures that the final product meets the highest standards of performance and functionality."
        },
        {
            icon: rt,
            title: "Robust Testing",
            desc: "Our skilled team conducts rigorous testing at various stages to ensure the final web application is error-free and glitch-free. We prioritize delivering a seamless user experience, ensuring that your application functions flawlessly."
        },
        {
            icon: deployment,
            title: "Deployment",
            desc: "After meticulous testing, our developers launch the web app, ensuring a smooth and efficient deployment process. We manage every aspect of the deployment to guarantee a successful launch."
        },
        {
            icon: sam,
            title: "Support and Maintenance",
            desc: "Finally, 360 Bytes provides ongoing support and maintenance to keep your web application optimized, secure, and up-to-date. Our commitment to continuous improvement ensures that your web app remains a valuable asset to your business over time."
        },
    ]

  return (
    <section className='wgbs-sec'>
        <div className='container'>
            <h3>What Goes on</h3>
            <h4>Behind-The-Scenes?</h4>
            <h5>Our Proven Web App Development Process</h5>
            <p className='plg'>We have meticulously crafted a strategic roadmap to guide you through each step of the web app development process, maximizing the potential of your project and ensuring its success.</p>
            <ul>
                {
                    wgbslist.map((Wgbs, index)=>(
                        <li key={index}>
                            <h6> <span className='wgbs-icon'><img src={Wgbs.icon} alt={Wgbs.title} width={64} height={64}/></span> <span className='wgbs-head'>{Wgbs.title}</span></h6>
                            <p>{Wgbs.desc}</p>
                        </li> 
                    ))
                }
                
            </ul>
            <p className='plg-28'>Let's embark on a new journey together. Reach out to us, and we'll connect to explore how we can best support your goals.</p>
            <button className='btn-main' onClick={() => navigate('/contact')}><span>Contact Us</span> <FaChevronRight/></button>
        </div>

    </section>
  )
}

export default Wgbs
